<template>
  <div class="col-md-4">
    <div class="card" @click="viewRedirect">
      <div class="card-content text-center">
        <div class="row d-flex align-items-center server-card-content">
          <div class="col-md-4">
            <div class="icon-big text-center" :class="statusDataItem('iconClass')">
              <i class="ti-server"></i>
            </div>
            <div>
              <span class="label" :class="statusDataItem('labelClass')">{{ statusDataItem('labelText') }}</span>
            </div>
          </div>
          <div class="col-md-8">
            <div v-if="isOnline">
              <div v-if="isActivated && server.usage">
                <div class="text-left">
                  <strong>CPU</strong>
                  <div class="progress">
                    <div class="progress-bar progress-bar-warning" role="progressbar" :style="{width: server.usage.cpu+'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="text-left">
                  <strong>RAM</strong>
                  <div class="progress">
                    <div class="progress-bar progress-bar-info" role="progressbar" :style="{width: server.usage.ram+'%'}" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
                <div class="text-left">
                  <strong>HDD</strong>
                  <div class="progress">
                    <div class="progress-bar progress-bar-success" role="progressbar" :style="{width: server.usage.hdd+'%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
              <div v-if="isPending">
                <p>Server is currently processing license activation.</p>
              </div>
              <div v-if="isNew">
                <div class="form-group">
                  <label>Select license for server</label>
                  <select class="form-control" v-model="activationLicense">
                    <option value="">Choose a license</option>
                    <option v-for="license in licenseByStatus(1)" :key="license.id" :value="license.id">{{ license.email }}</option>
                  </select>
                  <p class="text-left">
                    <small class="checkbox">
                      <input type="checkbox" :id="'vod-activation-'+ server.id" v-model="activationAsVod"/>
                      <label :for="'vod-activation-'+ server.id">Activate as "VOD Processor"</label>
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div v-if="isOffline">
              <button class="btn btn-fill btn-danger" @click="deleteServer()">Remove server</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <hr>
        <div class="footer-title">
          <strong>
            <span class="text-muted hidden">Hostname:</span>
            <span>{{ server.hostname }}</span>
          </strong>
          <span v-if="server.status === 3">
            <small class="label label-info" v-if="server.type === 1">Grab</small>
            <small class="label label-success" v-if="server.type === 2">VOD</small>
          </span>
          <span v-if="server.batch && server.batch.name">
            <small :class="'label label-'+server.batch.color">{{server.batch.name}}</small>
          </span>
        </div>
        <div class="pull-right" v-if="isOnline">
          <button class="btn btn-default btn-fill btn-icon btn-sm" v-if="isActivated">
            <i class="ti-angle-right"></i>
          </button>

          <button class="btn btn-success btn-fill btn-icon btn-sm" v-if="isNew" @click="activateLicense">
            Activate
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  props: ['server'],
  computed: {
    ...mapGetters(['licenseByStatus']),
    statusCode: function () {
      if (this.isOffline) return 4;
      return (this.server && this.server.status) ? this.server.status : 0;
    },
    isOnline: function () {
      return this.server.available;
    },
    isOffline: function () {
      return !this.isOnline;
    },
    isActivated: function () {
      return this.statusCode === this.statusCodes.activated;
    },
    isPending: function () {
      return this.statusCode === this.statusCodes.pending;
    },
    isNew: function () {
      return this.statusCode === this.statusCodes.new;
    },
  },
  data: function () {
    return {
      activationLicense: '',
      activationAsVod: false,
      statusData: {
        0: {
          iconClass: 'icon-default',
          labelClass: 'label-default',
          labelText: 'Unknown',
        },
        1: {
          iconClass: 'icon-warning',
          labelClass: 'label-warning',
          labelText: 'New',
        },
        2: {
          iconClass: 'icon-info',
          labelClass: 'label-info',
          labelText: 'Pending',
        },
        3: {
          iconClass: 'icon-success',
          labelClass: 'label-success',
          labelText: 'Online',
        },
        4: {
          iconClass: 'icon-danger',
          labelClass: 'label-danger',
          labelText: 'Offline',
        },
      },
      statusCodes: {
        unknown: 0,
        new: 1,
        pending: 2,
        activated: 3
      }
    }
  },
  methods: {
    ...mapActions(['serverDeleteById', 'licenseActivate']),
    viewRedirect: function () {
      if (this.isOnline && this.isActivated) {
        this.$router.push({name: 'server.view', params: {id: this.server.id}});
      }
    },
    statusDataItem: function (type) {
      return this.statusData[this.statusCode][type];
    },
    deleteServer: function () {
      this.serverDeleteById(this.server.id);
    },
    activateLicense: function () {
      const input = {
        client_id: this.server.id,
        action: 'license_activate',
        request: JSON.stringify({license_id: this.activationLicense, is_vod: this.activationAsVod})
      };
      this.licenseActivate(input);
    },
  }
}
</script>
<style>
.server-card-content {
  min-height: 145px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Servers/List/ServerCard.vue